import { useMutation } from "react-query";
import { updateFamilyMedicalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateFamilyMedicalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateFamilyMedicalHistory(id, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating the family medical history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateFamilyMedicalHistoryMutation: mutate,
    isUpdateFamilyMedicalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpdateFamilyMedicalHistory;
